export default (root: string) => {
    const specificRoot = `${root}/dashboard`;
    return {
        root: specificRoot,
        configure: `${specificRoot}/configure`,
    };
};
